import { render, staticRenderFns } from "./ClientUzum.vue?vue&type=template&id=aea3e440&"
import script from "./ClientUzum.vue?vue&type=script&lang=js&"
export * from "./ClientUzum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports